<template>
	<ValidationProvider
		ref="provider"
		:vid="idLabel"
		:rules="{ required: required }"
		:immediate="immediate"
		v-slot="{ failed }"
	>
		<ValidationObserver ref="validation" disabled slim v-slot="{ handleSubmit }">
			<div :class="{ 'form-group': true, 'exhibitor-badge-wrapper': true, 'is-invalid-wrapper': failed }">
				<div class="card mb-2">
					<div class="card-header">
						<p class="label m-0">
							<strong>{{ label }}</strong>
							<span class="required" v-if="required">*</span>
						</p>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-12" v-if="!value.length">
								<p>Use the form below to add badges for each staff member:</p>
							</div>
							<div class="col-12 d-flex flex-wrap" v-if="value.length">
								<div class="mr-2" v-for="(exhibitor, i) in value" :key="i">
									<div
										class="d-flex justify-content-between align-items-center alert alert-info alert-dismissible mb-2"
										style="line-height: 1"
									>
										<span class="mr-4">
											{{ exhibitor.firstname }}&nbsp;{{ exhibitor.surname }}
										</span>
										<button
											type="button"
											title="Remove"
											class="btn"
											style="padding: 0; background: transparent; color: inherit; font-size: 1.25rem; font-weight: 400; line-height: 1;"
											@click="removeBadge(exhibitor)"
										>
											<span>
												&times;
											</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<form method="post" class="m-0" ref="form" @submit.prevent="handleSubmit(onSubmit)">
						<div class="card-body">
							<div class="row">
								<div class="col-4">
									<text-input label="First Name" v-model="exhibitor.firstname" />
								</div>
								<div class="col-4">
									<text-input label="Last Name" v-model="exhibitor.surname" />
								</div>
								<div class="col-4">
									<text-input label="Position" v-model="exhibitor.position" :required="false" />
								</div>
							</div>
							<div class="row">
								<div class="col-6">
									<text-input label="Email Address" v-model="exhibitor.email" />
								</div>
								<div class="col-6">
									<text-input label="Mobile" v-model="exhibitor.mobile" />
								</div>
							</div>
						</div>
						<div class="card-footer text-right">
							<button type="submit" class="btn btn-primary">Add +</button>
						</div>
					</form>
				</div>
			</div>
		</ValidationObserver>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import textInput from './TextInput';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';
import '../Utils/validation';

export default {
	mixins: [formControlProps, validationProps],

	updated() {
		// Need to sync value when v-model on parent component updates;
		// ie, when the model is reset after a form submission
		//
		// https://vee-validate.logaretm.com/v3/advanced/model-less-validation.html#value-synchronization
		this.$refs.provider.syncValue(this.value);
	},

	props: {
		value: [Array, Object],
	},

	data() {
		return {
			exhibitor: {
				firstname: '',
				surname: '',
				position: '',
				email: '',
				mobile: '',
			},
		};
	},

	methods: {
		onSubmit() {
			let value = [...this.value, { ...this.exhibitor }];
			this.$emit('input', value);
			// https://vee-validate.logaretm.com/v3/advanced/model-less-validation.html#value-synchronization
			this.$refs.provider.syncValue(value);
			this.$refs.provider.validate();
			this.resetForm();
		},

		resetForm() {
			this.$refs.validation.reset();
			this.$refs.form.reset();
			Object.keys(this.exhibitor).map((k) => (this.exhibitor[k] = ''));
		},

		removeBadge(exhibitor) {
			let value = [...this.value.filter((x) => x !== exhibitor)];
			this.$emit('input', value);
			// https://vee-validate.logaretm.com/v3/advanced/model-less-validation.html#value-synchronization
			this.$refs.provider.syncValue(value);
		},
	},

	components: {
		ValidationProvider,
		ValidationObserver,
		textInput,
	},
};
</script>
